// The hero name is hand-traced calligraphy, so it ships as an image (see
// InkedImage and tools/calligraphy); the other Arabic words are live text in
// Gulzar (see InkedText). It is the LCP image, so it lives in public/ under a
// fixed URL that public/index.html can preload (keep the srcset and sizes there
// in sync). `srcSet` adds smaller copies for phones.
const nameUrl = (w) => `${process.env.PUBLIC_URL}/images/calligraphy/name-${w}.webp`;

export const calligraphy = {
	name: {
		src: nameUrl(1200),
		srcSet: `${nameUrl(400)} 400w, ${nameUrl(700)} 700w, ${nameUrl(1200)} 1200w`,
		width: 1200,
		height: 575,
	},
};
